"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionCard = void 0;
const React = __importStar(require("react"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const button_1 = require("@shared-modules/components/button");
const number_1 = require("@utils/object/number");
const user_mini_profile_1 = require("@components/user-mini-profile");
const object_1 = require("@utils/object");
require("./styles.scss");
const base_card_1 = require("../base-card");
const react_router_dom_1 = require("react-router-dom");
const translation_hooks_1 = require("@hooks/translation.hooks");
const tokens_reducer_1 = require("@app/store/reducers/tokens.reducer");
const AuctionCard = (props) => {
    const { auction, onClick, isOwner = false, tokenPageUrl } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("auctionCard");
    const { bids, minPrice, token, endAuctionDate, startAuctionDate } = auction;
    const secondsForStartLeft = (0, object_1.getTimeStampInSec)(startAuctionDate) - (0, object_1.getTimeStampInSec)();
    const isStartedAuction = secondsForStartLeft < 0;
    const secondsLeft = isStartedAuction ? (0, object_1.getTimeStampInSec)(endAuctionDate) - (0, object_1.getTimeStampInSec)() : secondsForStartLeft;
    const shortDuration = (0, object_1.maxDurationGranule)(secondsLeft);
    const lastBid = bids.sort((left, right) => new bignumber_js_1.default(right.amount).minus(left.amount).toNumber())[0];
    const paymentToken = (0, tokens_reducer_1.useTokenByAddress)(auction.paymentTokenAddress);
    const minPriceNormalized = (0, number_1.normalizeValue)(minPrice, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals);
    const lastBidNormalized = (0, number_1.normalizeValue)(lastBid === null || lastBid === void 0 ? void 0 : lastBid.amount, paymentToken === null || paymentToken === void 0 ? void 0 : paymentToken.decimals);
    return (React.createElement(base_card_1.BaseCard, { onPreviewClick: onClick, metadata: token.metadata, baseMetaDataUrl: token.metaUrlBase, tokenPageUrl: tokenPageUrl },
        React.createElement("div", { className: "c-auction-card" },
            React.createElement("div", { className: "c-auction-card__alert" }, shortDuration.value > 0
                ? `${translator(isStartedAuction ? "endInLabel" : "startInLabel")} ${shortDuration.value} ${shortDuration.title}`
                : translator("endedLabel")),
            React.createElement("div", { className: "c-auction-card__title" }, token.name),
            React.createElement("div", { className: "c-auction-card__info" },
                React.createElement("div", { className: "c-auction-card__info-section" },
                    React.createElement("div", { className: "c-auction-card__info-section-label" }, translator("currentBidLabel")),
                    React.createElement("div", { className: "c-auction-card__info-section-value" },
                        !lastBid && (0, number_1.formatBigNumber)(minPriceNormalized, [2]),
                        lastBid && (0, number_1.formatBigNumber)(lastBidNormalized, [2]),
                        " ", paymentToken === null || paymentToken === void 0 ? void 0 :
                        paymentToken.symbol)),
                React.createElement("div", { className: "c-auction-card__info-section" },
                    React.createElement("div", { className: "c-auction-card__info-section-label" }, translator("collectionLabel")),
                    React.createElement(react_router_dom_1.Link, { to: `/collections/${token.collectionId}`, className: "g-link c-auction-card__info-section-value" }, token.collection.title))),
            React.createElement("div", { className: "c-auction-card__footer" },
                React.createElement(user_mini_profile_1.UserMiniProfile, { title: translator("ownerLabel"), avatar: token.owner.avatar, displayName: (0, object_1.concatStringsWithWhitespace)(token.owner.firstName, token.owner.lastName), address: token.owner.wallet }),
                React.createElement(button_1.Button, { tag: "a", buttonUrl: tokenPageUrl, size: "small" }, isOwner ? translator("manageButton") : translator("bidButton"))))));
};
exports.AuctionCard = AuctionCard;
